import { PureComponent, ReactElement } from 'react';
import { Button } from 'antd';
import { Applet, SwitchOption } from '@methodset/application-client-ts';
import { SwitchOptionEditor } from './SwitchOptionEditor/SwitchOptionEditor';
import { Spacer } from 'components/Spacer/Spacer';
import update from 'immutability-helper';
import './SwitchOptions.less';

export type ChangeCallback = (options: SwitchOption[]) => void;

export type SwitchOptionsProps = typeof SwitchOptions.defaultProps & {
    applet: Applet,
    options?: SwitchOption[],
    onChange: ChangeCallback
}

export class SwitchOptions extends PureComponent<SwitchOptionsProps> {

    static defaultProps = {
        options: [] as SwitchOption[]
    }

    constructor(props: SwitchOptionsProps) {
        super(props);
        this.handleOptionAdd = this.handleOptionAdd.bind(this);
        this.handleOptionChange = this.handleOptionChange.bind(this);
        this.handleOptionRemove = this.handleOptionRemove.bind(this);
    }

    private handleOptionAdd(): void {
        const option = {} as SwitchOption;
        const options = update(this.props.options, {
            $push: [option]
        });
        this.props.onChange(options);
    }

    private handleOptionRemove(index: number): void {
        const options = update(this.props.options, {
            $splice: [[index, 1]]
        });
        this.props.onChange(options);
    }

    private handleOptionChange(option: SwitchOption, index: number): void {
        const options = update(this.props.options, {
            [index]: { $set: option }
        });
        this.props.onChange(options);
    }

    public render(): ReactElement {
        return (
            <Spacer className="x-switchoptions" direction="vertical" alignment="top" fill>
                {this.props.options.map((option, index) => (
                    <SwitchOptionEditor
                        key={index}
                        index={index}
                        applet={this.props.applet}
                        option={option}
                        onChange={this.handleOptionChange}
                        onRemove={this.handleOptionRemove}
                    />
                ))}
                <div className="x-switchoptions-add">
                    <Button onClick={this.handleOptionAdd}>Add Option</Button>
                </div>
            </Spacer>
        );
    }
}
